/** Registered on the map by `initializeMapIcons`, drawn above the winning pin. */
export const HIGHEST_COMPETITOR_CROWN_ICON = 'highest-performing-competitor-crown';

/** Pixels above the station. Tuned for the 36px pin; a 28px pin used -10. */
export const HIGHEST_COMPETITOR_CROWN_OFFSET_Y = -13;

/** Logical raster size, matched to the 32×36 pin. The 25×28 pin used 24×16. */
export const HIGHEST_COMPETITOR_CROWN_WIDTH = 31;
export const HIGHEST_COMPETITOR_CROWN_HEIGHT = 21;

/**
 * A filled crown, cropped to the crown itself. The bar that sits under the
 * Lucide crown is left out so the mark reads as the crown only.
 */
export function highestCompetitorCrownSvg(): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${HIGHEST_COMPETITOR_CROWN_WIDTH}" height="${HIGHEST_COMPETITOR_CROWN_HEIGHT}" viewBox="0 2 24 16">
    <path fill="#F5C518" d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/>
  </svg>`;
}
